/* eslint-disable class-methods-use-this */

const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      toggle: '.js-sidebar-toggle',
      sidebar: '.js-sidebar',
      dropdown: '.js-main-nav-dropdown',
    };

    this.classes = {
      toggle: 'is-open',
    };

    this.init();
  }

  init() {
    this.bindToggleEvent();
    this.adjustDropDown();
  }

  bindToggleEvent() {
    $(document).on('click', this.selectors.toggle, () => {
      $(this.selectors.sidebar).toggleClass(this.classes.toggle);
    });
  }

  adjustDropDown() {
    if (this.isTouchDevice()) {
      $(this.selectors.dropdown).on('click', event => {
        event.preventDefault();
      });
    }
  }

  isTouchDevice() {
    return !!('ontouchstart' in window);
  }
}();



// WEBPACK FOOTER //
// ./src/scripts/modules/navigation.js